var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Внесение данных")]),_c('el-divider'),_c('h4',[_vm._v("Результаты поиска")]),_c('data-entry-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }